import React, { useState, useEffect, useCallback } from 'react';
import {
  Typography,
  TextField,
} from "@mui/material";

// Tab 1: RFQ Information
const RFQInformationTab = ({
    title,
    setTitle,
    createDate,
    setCreateDate,
    submitedDate,
    setSubmitedDate,
    validUntil,
    setValidUntil,
    buyerEmailID,
    errors,
    isViewMode,
  }) => {
    const handleTitleChange = useCallback(
      (e) => {
        if (!isViewMode) setTitle(e.target.value);
      },
      [setTitle, isViewMode]
    );
  
    const handleValidUntilChange = useCallback(
      (e) => {
        if (!isViewMode) setValidUntil(e.target.value);
      },
      [setValidUntil, isViewMode]
    );
  
    return (
      <div className="row g-3">
        <div className="col-md-6">
          <Typography variant="body2">RFQ Title *</Typography>
          <TextField
            value={title}
            onChange={handleTitleChange}
            sx={{ backgroundColor: "white", width: "100%" }}
            placeholder="Enter RFQ Title"
            error={!!errors.title}
            helperText={errors.title}
            disabled={isViewMode}
          />
        </div>
        <div className="col-md-6">
          <Typography variant="body2">Buyer/Trader Name</Typography>
          <TextField
            value={buyerEmailID}
            sx={{ backgroundColor: "white", width: "100%" }}
            disabled={true}
          />
        </div>
        <div className="col-md-4">
          <Typography variant="body2">Creation Date</Typography>
          <TextField
            value={createDate}
            sx={{ backgroundColor: "white", width: "100%" }}
            disabled={true}
          />
        </div>
        <div className="col-md-4">
          <Typography variant="body2">Submission Date</Typography>
          <TextField
            value={submitedDate}
            sx={{ backgroundColor: "white", width: "100%" }}
            disabled={true}
          />
        </div>
        <div className="col-md-4">
          <Typography variant="body2">RFQ Expiry Date/Time *</Typography>
          <TextField
            type="date"
            value={validUntil}
            onChange={handleValidUntilChange}
            sx={{ backgroundColor: "white", width: "100%" }}
            error={!!errors.validUntil}
            helperText={errors.validUntil}
            inputProps={{
              min: new Date().toISOString().split("T")[0],
            }}
            disabled={isViewMode}
          />
        </div>
      </div>
    );
  };
  export default RFQInformationTab;